import React from 'react'

function BrandTwo() {
    return (
        <div>
            {/* start client area */}
            <div className="rts-client-area ptb--100 client-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="client-two-wrapper">
                                <img src="assets/images/client/01.png" alt="Business_client" />
                                <img src="assets/images/client/02.png" alt="Business_client" />
                                <img src="assets/images/client/03.png" alt="Business_client" />
                                <img src="assets/images/client/04.png" alt="Business_client" />
                                <img src="assets/images/client/05.png" alt="Business_client" />
                                <img src="assets/images/client/06.png" alt="Business_client" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* start client area End */}
        </div>
    )
}

export default BrandTwo